var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
      },
    },
    [
      _c("g", { attrs: { transform: "translate(-10725 9180)" } }, [
        _c("g", { attrs: { transform: "translate(10104 -11147)" } }, [
          _c(
            "g",
            {
              attrs: {
                transform: "translate(621 1967)",
                fill: "#fff",
                stroke: "#1b1b1b",
                "stroke-width": "1.5",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "16", cy: "16", r: "16", stroke: "none" },
              }),
              _c("circle", {
                attrs: { cx: "16", cy: "16", r: "15.25", fill: "none" },
              }),
            ]
          ),
        ]),
        _c("rect", {
          attrs: {
            width: "4",
            height: "14",
            rx: "1",
            transform: "translate(10739 -9171)",
            fill: "#ffde01",
          },
        }),
        _c("rect", {
          attrs: {
            width: "4",
            height: "14",
            rx: "1",
            transform: "translate(10748 -9166) rotate(90)",
            fill: "#ffde01",
          },
        }),
        _c(
          "g",
          { attrs: { transform: "translate(20655 -18195)", fill: "none" } },
          [
            _c("path", {
              attrs: {
                d: "M-9915,9038a1,1,0,0,1-1-1v-4h-4a1,1,0,0,1-1-1v-2a1,1,0,0,1,1-1h4v-4a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v4h4a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1h-4v4a1,1,0,0,1-1,1Z",
                stroke: "none",
              },
            }),
            _c("path", {
              attrs: {
                d: "M -9913.0009765625 9037 L -9913 9036.9990234375 L -9913 9033 L -9913 9032 L -9912 9032 L -9908 9032 L -9908.0009765625 9029.9990234375 L -9912 9029.9990234375 L -9913 9029.9990234375 L -9913 9028.9990234375 L -9913.0009765625 9025 L -9915.0009765625 9025.0009765625 L -9915.0009765625 9028.9990234375 L -9915.0009765625 9029.9990234375 L -9916.0009765625 9029.9990234375 L -9920 9030 L -9919.9990234375 9032 L -9916.0009765625 9032 L -9915.0009765625 9032 L -9915.0009765625 9033 L -9915 9037 L -9913.0009765625 9037 M -9913.0009765625 9038 L -9915 9038 C -9915.552734375 9038 -9916.0009765625 9037.5517578125 -9916.0009765625 9036.9990234375 L -9916.0009765625 9033 L -9919.9990234375 9033 C -9920.5517578125 9033 -9921 9032.552734375 -9921 9032 L -9921 9030 C -9921 9029.447265625 -9920.5517578125 9028.9990234375 -9919.9990234375 9028.9990234375 L -9916.0009765625 9028.9990234375 L -9916.0009765625 9025.0009765625 C -9916.0009765625 9024.4482421875 -9915.552734375 9024 -9915 9024 L -9913.0009765625 9024 C -9912.4482421875 9024 -9912 9024.4482421875 -9912 9025.0009765625 L -9912 9028.9990234375 L -9908.0009765625 9028.9990234375 C -9907.4482421875 9028.9990234375 -9907 9029.447265625 -9907 9030 L -9907 9032 C -9907 9032.552734375 -9907.4482421875 9033 -9908.0009765625 9033 L -9912 9033 L -9912 9036.9990234375 C -9912 9037.5517578125 -9912.4482421875 9038 -9913.0009765625 9038 Z",
                stroke: "none",
                fill: "#1b1b1b",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }